module.exports = __webpack_public_path__ + "img/dashboard_active.9fb1e3c8.svg";